import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { ClientMyPageProject, } from '@/pages/mypage/client/ClientMyPageProject/ClientMyPageProject';
export const ClientMyPageProjectAuth = (props) => {
    const { location, match } = props;
    // 認証周りの判定取得
    const { message: authRedirectMessage, profile, redirectTo: authRedirectTo, } = useAuthentication({ isClient: true });
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return (_jsx(ClientMyPageProject, { location: location, match: match, profile: profile }));
};
